import { useContext } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { globalStates } from "../App";

export default function SectionLayout({ children, id, index }) {
  const { setSectionInView, setShowHeader } = useContext(globalStates);

  return (
    <AnimationOnScroll
      animateIn
      afterAnimatedIn={() => {
        setSectionInView(index);
        if (id === "hero") setShowHeader(false);
        else setShowHeader(true);
      }}
      duration={0}
      delay={0}
    >
      <div
        id={id}
        className=" overflow-x-hidden snap-start  min-h-screen flex flex-col content-center items-center justify-center  max-w-screen-xl m-auto sm:p-10 selection:bg-gray-600"
      >
        {children}
      </div>
    </AnimationOnScroll>
  );
}
